import { environment } from '../../environments/environment';

/**
 * Converts a hex string to a Uint8Array.
 */
function hexToBytes(hex: string): Uint8Array {
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.substring(i, i + 2), 16);
  }
  return bytes;
}

/**
 * Converts an ArrayBuffer to a hex string.
 */
function bufferToHex(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Generates an HMAC-SHA256 signature for the given identifier.
 * Uses the Web Crypto API (SubtleCrypto) with the secret key from environment.
 */
export async function signIdentifier(identifier: string): Promise<string> {
  const keyBytes = hexToBytes(environment.hmacSecretKey);

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyBytes,
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );

  const encoder = new TextEncoder();
  const data = encoder.encode(identifier);
  const signature = await crypto.subtle.sign('HMAC', cryptoKey, data);

  return bufferToHex(signature);
}

/**
 * Builds the full QR code content: "identifier|signature"
 */
export async function buildQrContent(identifier: string): Promise<string> {
  const signature = await signIdentifier(identifier);
  return `${identifier}|${signature}`;
}
